<template>
  <div>
    <b-row align="left">
      <b-col md="6" class="mt-2">
        <p class="mb-1 font-weight-bold">
          <font class="h4 text-primary">Global Search</font>
        </p>
      </b-col>
    </b-row>
    <br />
    <div class="text-left">
      <b-row>
        <b-col md="12">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex flex-wrap w-50">
              <b-button class="bg-white text-primary border-secondary mr-4" @click="modalFilterData = !modalFilterData">
                <span class="d-flex"><img src="@/assets/filter.svg" width="15px" alt />&nbsp;Filter Data</span>
              </b-button>
              <!-- <b-col md="2"> -->
                <b-form-group label-cols-sm="3" label="Show" class="mb-0 w-25">
                  <b-form-select v-model="perPage" :options="pageOptions" class="col-md-6"></b-form-select>
                </b-form-group>
              <!-- </b-col> -->
            </div>
            <div class="d-flex flex-wrap">
              <router-link :to="{ name: 'createGlobalSearch' }">
                <b-button variant="primary">
                  <img src="@/assets/create-new.svg" width="15px" class="mr-2" alt />Create New
                </b-button>
              </router-link>
            </div>
          </div>
        </b-col>
      </b-row>
      <br />
      <b-table
        responsive
        show-empty
        hover
        ref="globalSearchTable"
        :items="getDataGlobalSearch"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(no)="data">
          <p class="mb-0">{{getSequenceNumber(data.index)}}</p>
        </template>
        <template v-slot:cell(type_name)="{ item }">
          <p class="mb-0">{{item.type_desc}}</p>
        </template>
        <template v-slot:cell(language)>
          <p class="mb-0">En</p>
          <p class="mb-0">Id</p>
        </template>
        <template v-slot:cell(meta_title)="{ item }">
          <p class="mb-0">{{item.meta_title_en === "" ? "Empty" : item.meta_title_en.substring(0,25)+"..."}}</p>
          <p class="mb-0">{{item.meta_title_id === "" ? "Empty" : item.meta_title_id.substring(0,25)+"..."}}</p>
        </template>
        <template v-slot:cell(meta_description)="{ item }">
          <p class="mb-0">{{item.meta_desc_en === "" ? "Empty" : item.meta_desc_en.substring(0,25)+"..."}}</p>
          <p class="mb-0">{{item.meta_desc_id === "" ? "Empty" : item.meta_desc_id.substring(0,25)+"..."}}</p>
        </template>
        <template v-slot:cell(content)="{ item }">
          <p class="mb-0">{{item.content_en === "" ? "Empty" : item.content_en.substring(0,25)+"..."}}</p>
          <p class="mb-0">{{item.content_id === "" ? "Empty" : item.content_id.substring(0,25)+"..."}}</p>
        </template>
        <template v-slot:cell(url)="{ item }">
          <p class="mb-0">{{item.url_en.substring(0,25)}}...</p>
          <p class="mb-0">{{item.url_id.substring(0,25)}}...</p>
        </template>
        <template v-slot:cell(action)="{item}">
          <div class="row">
            <div class="col-md-3">
              <router-link
                v-if="item.sync_type != 'auto'"
                v-b-tooltip.hover
                title="Edit"
                :to="{name: 'editGlobalSearch', params: {id: item.id}}"
                class="text-dark"
              >
                <img src="@/assets/ic-edit.svg" alt="edit" width="20" height="20" />
              </router-link>
              <span v-else></span>
            </div>
            <div class="col-md-3">
              <b-link v-b-tooltip.hover title="View" class="text-dark" @click="modalViewShow = !modalViewShow">
                <img src="@/assets/ic-view-detail.svg" alt="view" @click="viewItem(item.id)" width="20" height="20" />
              </b-link>
            </div>
            <div class="col-md-3">
              <b-link v-if="item.sync_type != 'auto'" v-b-tooltip.hover title="Delete" class="text-dark" @click="deleteItem(item.id)">
                <img src="@/assets/rectangle.svg" alt="delete" width="20" height="20" />
              </b-link>
              <span v-else></span>
            </div>
          </div>
        </template>
      </b-table>
      <b-row class="mx-auto">
        <b-col md="4" align="left" class="mx-auto px-0">
          <div v-if="totalRows == 0 || totalRows == null">
            Showing 0 Records
          </div>
          <div v-else>
            Showing {{ fromPage[currentPage - 1] }} to
            {{ toPage[currentPage - 1] }} of {{ totalRows }} Records
          </div>
        </b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
    <b-modal
      v-model="modalFilterData"
      size="l"
      hide-header
      hide-footer
      no-close-on-esc
      no-close-on-backdrop>
      <div class="container">
        <b-row>
          <b-col>
            <h5 class="font-weight-bold mt-3">Filter Data</h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group
              id="fieldset-content-type"
              label="Type"
              class="font-weight-bold"
              label-for="input-content-type"
            >
              <b-form-select
                v-model="content_type_filtered"
                name="content_type_filtered"
                class="mb-3"
              >
                <template v-slot:first>
                  <option value="">All</option>
                </template>
                <option
                  v-for="content_type in content_types"
                  :key="content_type.type_name"
                  :value="content_type.type_name"
                >
                  {{ content_type.type_desc }}
                </option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <br />
        <b-row style="text-align-last: right">
          <b-col>
            <b-button
              variant="light"
              @click="resetFilterData()"
              class="text-primary border-secondary btn-secondary mr-3"
              size="lg"
              >
              Reset
            </b-button>
            <b-button variant="primary" size="lg" @click="filterData()">Apply</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal v-model="modalViewShow" size="l" ok-only hide-header>
      <b-row>
        <b-col>
          <h5 class="font-weight-bold">Preview</h5>
        </b-col>
        <b-col class="text-right">
          <i class="fas fa-times" @click="modalViewShow = !modalViewShow" style="cursor: pointer;"></i>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="12">
          <b-row>
            <b-col md="3" class="font-weight-bold">Meta Title Bahasa</b-col>
            <b-col md="8">{{ global_search_detail.meta_title_id }}</b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="font-weight-bold">Meta Title English</b-col>
            <b-col md="8">{{ global_search_detail.meta_title_en }}</b-col>
          </b-row>
          <br />
          <b-row>
            <b-col md="3" class="font-weight-bold">Meta Description Bahasa</b-col>
            <b-col md="8">{{ global_search_detail.meta_desc_id }}</b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="font-weight-bold">Meta Description English</b-col>
            <b-col md="8">{{ global_search_detail.meta_desc_en }}</b-col>
          </b-row>
          <br />
          <b-row>
            <b-col md="3" class="font-weight-bold">Content Bahasa</b-col>
            <b-col md="8">{{ global_search_detail.content_id }}</b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="font-weight-bold">Content English</b-col>
            <b-col md="8">{{ global_search_detail.content_en }}</b-col>
          </b-row>
          <br />
          <b-row>
            <b-col md="3" class="font-weight-bold">URL Bahasa</b-col>
            <b-col md="8">{{ global_search_detail.url_id }}</b-col>
          </b-row>
          <b-row>
            <b-col md="3" class="font-weight-bold">URL English</b-col>
            <b-col md="8">{{ global_search_detail.url_en }}</b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading_global_search: false,
      modalFilterData: false,
      modalViewShow: false,
      global_search_content: [],
      global_search_detail: {},
      content_types: [],
      content_type_filtered: "",
      fields: [
        {
          key: "no",
          label: "No",
          class: "text-center"
        },
        {
          key: "type_name",
          label: "Type",
          sortable: false,
          class: "text-left"
        },
        {
          key: "language",
          label: "Language",
          sortable: false,
          class: "text-left"
        },
        {
          key: "meta_title",
          label: "Meta Title",
          sortable: false,
          class: "text-left"
        },
        {
          key: "meta_description",
          label: "Meta Description",
          sortable: false,
          class: "text-left"
        },
        {
          key: "content",
          label: "Content",
          sortable: false,
          class: "text-left"
        },
        {
          key: "url",
          label: "URL",
          sortable: false,
          class: "text-left"
        },
        { key: "action", label: "Action", class: "text-left w-10" }
      ],
      fromPage: [],
      toPage: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: true,
      sortDirection: "asc",
    };
  },
  beforeCreate() {
    this.$store
      .dispatch("GlobalSearchModule/getContentTypes")
      .then((response) => {
        this.content_types = response.data.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    getSequenceNumber(index) {
      return ((this.currentPage - 1) * this.perPage) + (index + 1)
    },
    resetFilterData() {
      this.modalFilterData = !this.modalFilterData;
      this.content_type_filtered = "";
      this.$refs.globalSearchTable.refresh();
    },
    filterData() {
      this.modalFilterData = !this.modalFilterData;
      this.$refs.globalSearchTable.refresh();
    },
    getDataGlobalSearch(ctx, callback) {
      this.loading_global_search = true;
      const vm = this;
      const formData = new FormData();
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", false);
      formData.append("type_name", this.content_type_filtered);
      this.$store
        .dispatch("GlobalSearchModule/getGlobalSearchWithPaging", formData)
        .then(response => {
          vm.totalRows = response.data.data.total_record;
          var from = [];
          var to = [];
          var sum = 0;
          for (let i = 1; i <= vm.currentPage; i++) {
            sum = i * vm.perPage;
            if (vm.totalRows <= sum) {
              from.push(sum - vm.perPage + 1);
              to.push(vm.totalRows - sum + sum);
            } else {
              from.push(sum - vm.perPage + 1);
              to.push(sum);
            }
          }
          this.fromPage = from;
          this.toPage = to;
          this.global_search_content = response.data.data.results || [];
          callback(response.data.data.results || []);
          this.loading_global_search = false;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Error!",
            text: error.response ? error.response.data.message : "Failed get global search content",
            showConfirmButton: false,
            timer: 1500,
          });
          this.loading_global_search = false;
          callback([]);
        });
      return null;
    },
    viewItem(id) {
      this.$store
        .dispatch("GlobalSearchModule/getGlobalSearch", id)
        .then(response => {
          this.global_search_detail = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    deleteItem(id) {
      this.$swal({
        title: "Are you sure want to delete?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#6051a2",
        cancelButtonColor: "#f8f9fc",
        cancelButtonClass: "text-primary",
        confirmButtonText: "Delete",
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("GlobalSearchModule/deleteGlobalSearch", id)
          .then((response) => {
            this.$refs.globalSearchTable.refresh();
            this.$swal("Deleted!", "Your data has been deleted.", "success");
          })
          .catch((error) => {
            this.$swal({
              type: "error",
              title: "Oops...",
              text: error.response.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            console.log(error);
          });
        }
      });
    }
  }
};
</script>
